module.exports = {"activation.modal.content.text":"Espera mientras iniciamos tu sesión y activamos tu suscripción.","activation.modal.content.status":"Activando"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/es/components/ModalContent/Activation.json
// module id = 762
// module chunks = 0